import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { getOrgId } from "utils/storage";

import Paths from "./paths";
import * as Types from "./types";

export const departmentListService = (params: Types.DepartmentListRequest) =>
  RestAPIClient.call<Types.DepartmentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const departmentListShortService = (
  params: Types.DepartmentListRequest
) =>
  RestAPIClient.call<Types.DepartmentListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const departmentCreateService = (
  params: Types.DepartmentCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const departmentDetailService = (id: number) =>
  RestAPIClient.call<Types.Department>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{OrgId}", getOrgId())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const departmentUpdateService = (
  params: Types.DepartmentUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace("{OrgId}", getOrgId())}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
